import * as antIc from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import { useEffectOnce } from "react-use";
import { useAppSelector } from "../app/hooks";
import LogoVietTel from "../assets/img/logo/logo_viettel_manufacturing.png";
import { getLanguagesAction } from "../screens/language/slice";
import { IUserState } from "../screens/user/propState";
import { getUserRoleAction } from "../screens/user/slice";
import { isCheckPermisson } from "../utils";
import { PERMISSION_ENUM } from "../utils/permisson.enum";
import { ISider } from "./propsState";
import "./styles.scss";

const { Sider } = Layout;
const { SubMenu } = Menu;
type MenuItem = Required<MenuProps>["items"][number];
// router menu
const SiderBarComponent = (props: ISider) => {
  const dispatch = useDispatch();
  const [defaultOpenKeys] = useState([props.location.pathname || "/post"]);
  const [selectedkey, setSelectedKey] = useState([
    props.location.pathname || "/post",
  ]);

  const getRole = async () => {
    await dispatch(getUserRoleAction({}) as any);
    const language = localStorage.getItem("language");
    if (!language) {
      dispatch(getLanguagesAction({}) as any);
    }
  };
  useEffectOnce(() => {
    getRole();
  });
  const userState = useAppSelector<IUserState>((state) => state.screens.user);
  const permissionObj = userState.permissionObj;
  useEffect(() => {
  }, [props.location.pathname]);

  const onClick: MenuProps["onClick"] = (e) => {
    setSelectedKey([e.key]);
  };

  type MenuItem = Required<MenuProps>["items"][number];
  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    permission?: PERMISSION_ENUM | PERMISSION_ENUM[],
    children?: MenuItem[],
    type?: "group",
  ): MenuItem {
    return isCheckPermisson(permissionObj, permission)
      ? ({
        key,
        icon,
        children,
        label,
        type,
      } as MenuItem)
      : null;
  }
  const items: MenuItem[] = [
    getItem(
      <NavLink to="/">
        <span>Trang chủ</span>
      </NavLink>,
      "dashboard",
      <antIc.DashboardOutlined style={{ color: "orange" }} />
    ),
    getItem(
      <NavLink to="/post">
        <span>Bài viết</span>
      </NavLink>,
      "post",
      <antIc.BookOutlined style={{ color: "blue" }} />,
      [PERMISSION_ENUM.POST_CREATE, PERMISSION_ENUM.POST_LIST],
    ),
    getItem(
      <NavLink to="/product">
        <span>Sản phẩm</span>
      </NavLink>,
      "product",
      <antIc.ShoppingOutlined style={{ color: "deeppink" }} />,
      [PERMISSION_ENUM.POST_CREATE, PERMISSION_ENUM.POST_LIST],
    ),
    getItem(
      <NavLink to="/category">
        <span>Danh mục</span>
      </NavLink>,
      "category",
      <antIc.ApartmentOutlined style={{ color: "coral" }} />,
      [PERMISSION_ENUM.CATEGORY_CREATE, PERMISSION_ENUM.CATEGORY_LIST],
    ),
    getItem(
      <NavLink to="/banner">
        <span>Trình chiếu</span>
      </NavLink>,
      "banner",
      <antIc.DesktopOutlined style={{ color: "darkcyan" }} />,
      [PERMISSION_ENUM.BANNER_CREATE, PERMISSION_ENUM.BANNER_LIST],
    ),

    getItem(
      <NavLink to="/recruiment">
        <span>Tuyển dụng</span>
      </NavLink>,
      "recruiment",
      <antIc.PhoneOutlined style={{ color: "maroo" }} />,
      [PERMISSION_ENUM.RECRUIMENT_CREATE, PERMISSION_ENUM.RECRUIMENT_LIST],
    ),
    getItem(
      <NavLink to="/partner">
        <span>Đối tác</span>
      </NavLink>,
      "partner",
      <antIc.MessageOutlined style={{ color: "teal" }} />,
      [PERMISSION_ENUM.PARTNER_CREATE, PERMISSION_ENUM.PARTNER_LIST],
    ),
    getItem(
      <NavLink to="/certificate">
        <span>Chứng chỉ</span>
      </NavLink>,
      "certificate",
      <antIc.SafetyCertificateOutlined style={{ color: "slategrey" }} />,
      [PERMISSION_ENUM.CERTIFICATE_CREATE, PERMISSION_ENUM.CERTIFICATE_LIST],
    ),
    getItem(
      "Liên hệ",
      "contact",
      <antIc.ContactsOutlined style={{ color: "lime" }} />,
      [PERMISSION_ENUM.CONTACT_CREATE, PERMISSION_ENUM.CONTACT_LIST, PERMISSION_ENUM.INFOR_CONTACT_CREATE, PERMISSION_ENUM.INFOR_CONTACT_LIST],
      [
        getItem(
          <NavLink to="/contact">
            <span>Thông tin</span>
          </NavLink>,
          "contact",
          <antIc.InfoCircleOutlined style={{ color: "aqua" }} />,
          [PERMISSION_ENUM.CONTACT_CREATE, PERMISSION_ENUM.CONTACT_LIST],
        ),
        getItem(
          <NavLink to="/infor/contact">
            <span>Địa chỉ</span>
          </NavLink>,
          "inforContact",
          <antIc.EnvironmentOutlined style={{ color: "#ff4b2b" }} />,
          [PERMISSION_ENUM.INFOR_CONTACT_CREATE, PERMISSION_ENUM.INFOR_CONTACT_LIST],
        ),
      ]
    ),

    getItem(
      <NavLink to="/language">
        <span>Ngôn ngữ</span>
      </NavLink>,
      "language",
      <antIc.TranslationOutlined style={{ color: "sienna" }} />,
      [PERMISSION_ENUM.LANGUAGE_CREATE, PERMISSION_ENUM.LANGUAGE_LIST],
    ),
    getItem(
      "Người dùng",
      "user",
      <antIc.TeamOutlined style={{ color: "navy" }} />,
      [PERMISSION_ENUM.USER_CREATE, PERMISSION_ENUM.USER_LIST],
      [
        getItem(
          <NavLink to="/user">
            <span>Danh sách</span>
          </NavLink>,
          "userList",
          <antIc.ProfileOutlined style={{ color: "darkcyan" }} />,
          [PERMISSION_ENUM.USER_CREATE, PERMISSION_ENUM.USER_LIST],
        ),
        getItem(
          <NavLink to="/role">
            <span>Phân quyền</span>
          </NavLink>,
          "role",
          <antIc.SecurityScanOutlined style={{ color: "gray" }} />,
          [PERMISSION_ENUM.ROLE_CREATE, PERMISSION_ENUM.ROLE_LIST],
        )
      ]
    ),
  ];

  return (
    <Sider
      className="h-screen overflow-auto scrollbar"
      theme="light"
      trigger={null}
      collapsible
      collapsed={props.collapsed}
      breakpoint="lg"
      style={{
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
      }}
    >
      <div className="logo p-4">
        <img key="logo" about="logo" src={LogoVietTel} className="p-1" />
        {/* <Logo /> */}
      </div>
      <Menu
        theme="light"
        mode="inline"
        onClick={onClick}
        selectedKeys={selectedkey}
        defaultOpenKeys={defaultOpenKeys}
        className="mt-2"
        items={items}
      // className="position-fixed"
      />
    </Sider>
  );
};

export default withRouter(SiderBarComponent);
